import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { computed } from 'vue'

import AnimatedPlaceholder from '@/components_new/AnimatedPlaceholder.vue'
import BaseLink from '@/components_new/BaseLink.vue'
import CardContainer from '@/components_new/CardContainer.vue'
import { IconNameType } from '@/components_new/Icon'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { ROUTE_NAMES, ROUTE_NAMES_GAME_GROUPS } from '@/router/constants'


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchCards',
  props: {
    cards: {}
  },
  setup(__props: any) {

const props = __props

const cardsWithPlaceHolders = computed(() => {
    if (props.cards) {
        return props.cards
    }
    return Array<undefined>(3).fill(undefined)
})

function getLink(routeName: typeof ROUTE_NAMES.GAME_PAGE | ROUTE_NAMES_GAME_GROUPS, hru: string) {
    if (routeName === ROUTE_NAMES.GAME_PAGE) {
        return { name: routeName, params: { game: hru } }
    }
    return { name: routeName, params: { hru } }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass(_ctx.$style.cards)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardsWithPlaceHolders.value, (card) => {
      return (_openBlock(), _createElementBlock("li", {
        key: card?.hru
      }, [
        (!card)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.card)
            }, [
              _createVNode(CardContainer, {
                src: undefined,
                class: _normalizeClass(_ctx.$style.image_override)
              }, null, 8, ["class"]),
              _createVNode(AnimatedPlaceholder, {
                class: _normalizeClass(_ctx.$style.title_placeholder)
              }, null, 8, ["class"])
            ], 2))
          : (_openBlock(), _createBlock(BaseLink, {
              key: 1,
              class: _normalizeClass(_ctx.$style.card),
              to: getLink(card.routeName || _unref(ROUTE_NAMES).GAME_PAGE, card.hru)
            }, {
              default: _withCtx(() => [
                _createVNode(CardContainer, {
                  src: card.preview,
                  class: _normalizeClass(_ctx.$style.image_override)
                }, {
                  default: _withCtx(() => [
                    (card.previewIcon)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          name: card.previewIcon,
                          class: _normalizeClass(_ctx.$style.preview_icon)
                        }, null, 8, ["name", "class"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["src", "class"]),
                _createVNode(Typography, {
                  type: "label",
                  size: "m"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(card.title), 1)
                  ]),
                  _: 2
                }, 1024),
                (card.statusIcon)
                  ? (_openBlock(), _createBlock(Icon, {
                      key: 0,
                      name: card.statusIcon,
                      class: _normalizeClass(_ctx.$style.icon)
                    }, null, 8, ["name", "class"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class", "to"]))
      ]))
    }), 128))
  ], 2))
}
}

})